document.addEventListener('DOMContentLoaded', () => {
    new Swiper('.locSwiper', {
        slidesPerView: 'auto',
        spaceBetween: 24,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            1280: {
                slidesPerView: 4, // disable swiper
                spaceBetween: 0,
            }
        }
    });
});
